import { apiWrapper } from "@/services/api";
import store from "@/store/index";
import moment from "@/services/moment";

export const getExternalCoupons = async (isPast) => {
  try {
    let response;
    let coupons;

    if (isPast) {
      const now = moment();
      response = await apiWrapper(
        "GET",
        `coupons?to_created_at=${now.format()}`,
        {},
        true
      );
      coupons = response.data.filter((coupon) => {
        return moment(coupon.hold_limited_at).isBefore(now);
      });
    } else {
      response = await apiWrapper("GET", "coupons", {}, true);
      coupons = response.data;
    }

    const promises = coupons.map((coupon) => {
      return getMasterCouponById(coupon.master_coupon_id);
    });

    const masterCoupons = await Promise.allSettled(promises);

    coupons = coupons.map((coupon, index) => {
      return {
        ...coupon,
        _masterCoupon: masterCoupons?.[index]?.value,
      };
    });

    store.commit("coupon/setExternalCoupons", coupons);

    return coupons;
  } catch (err) {
    console.log('ERROR"" getExternalCoupons():', err);
    throw err;
  }
};

export const getExternalCoupon = async (id) => {
  try {
    const response = await apiWrapper("GET", `coupons/${id}`, {}, true);

    store.commit("coupon/setExternalCoupon", response.data);

    return response.data;
  } catch (err) {
    console.log('ERROR"" getExternalCoupon():', err);
    throw err;
  }
};

export const getMasterCoupon = async () => {
  try {
    const coupon = store.getters["coupon/externalCoupon"];
    if (!coupon?.master_coupon_id) throw "Coupon do not existed";

    const response = await apiWrapper(
      "GET",
      `master_coupons/${coupon.master_coupon_id}`,
      {},
      true
    );

    store.commit("coupon/setMasterCoupon", response.data);

    return response.data;
  } catch (err) {
    console.log('ERROR"" getMasterCoupon():', err);
    throw err;
  }
};

const getMasterCouponById = async (id) => {
  try {
    const response = await apiWrapper("GET", `master_coupons/${id}`, {}, true);

    return response.data;
  } catch (err) {
    console.log('ERROR"" getMasterCoupon():', err);
    throw err;
  }
};
